const Input = {
  baseStyle: {
    field: {
      _disabled: {
        bgColor: '#F4F5F5',
        color: '#6A7171',
        cursor: 'not-allowed',
        opacity: 1,
        border: '1px solid #C0C4C4',
      },
    },
  },
  variants: {
    outline: {
      field: {
        borderColor: '#c2c4cc',
        _focus: {
          borderColor: 'primary',
          boxShadow: 'none',
        },
        _invalid: {
          boxShadow: 'none',
          _focus: {
            borderColor: '#E53E3E',
          },
        },
      },
    },
  },
  sizes: {
    sm: {
      field: {
        borderRadius: 'md',
        fontSize: 'md',
        h: {
          base: '32px',
        },
        px: '12px',
      },
      addon: {
        h: '20px',
        bgColor: 'red',
      },
    },
    md: {
      field: {
        borderRadius: 'md',
        fontSize: '14px',
        h: {
          base: '40px',
        },
        px: '16px',
        py: '10px',
      },
    },
  },
}

export default Input
